import clsx from 'clsx';

import { allCompanies } from '..';

export type CompanyTagProps = React.PropsWithChildren<{
	company: string;
}>;

export function CompanyTag({ company, children }: CompanyTagProps) {
	const normalizedCompany = company.toLowerCase();

	return (
		<div
			className={clsx(
				{
					'bg-[#0077FF]/10 text-[#0077FF]': normalizedCompany === 'вк',
					'bg-[#FFFBE6] text-[#D48806]': normalizedCompany === 'желтый банк',
					'bg-[#F8604A]/10 text-[#FF604A]': normalizedCompany === 'яндекс',
					'bg-[#F6FFED] text-[#52C41A]': normalizedCompany === 'авито',
					'bg-[#F6FFED] text-[#389E0D]': normalizedCompany === 'сбер',
					'bg-[#005BFF]/10 text-[#005BFF]': normalizedCompany === 'озон',
					'bg-gray-1/10 text-gray-1': !allCompanies.includes(normalizedCompany),
				},
				'flex items-center gap-1 whitespace-nowrap rounded-lg px-2 py-1 text-sm',
			)}
		>
			{children}
		</div>
	);
}
